import React from 'react';

const AudienceExtensionExample = () => (
  <>
    <p>
      Enough theory. Here is a realistic ninety-day campaign with numbers
      you can pressure-test against your own audience and advertiser base.
      Assumptions are conservative on purpose — pick them apart and adjust
      to your reality.
    </p>

    <h2>The setup</h2>
    <ul>
      <li>
        <strong>Publisher:</strong> mid-market B2B media brand, roughly 500k
        opted-in professionals across newsletter and site.
      </li>
      <li>
        <strong>Advertiser:</strong> enterprise SaaS vendor targeting CFOs
        at financial services companies with $500M+ revenue.
      </li>
      <li>
        <strong>Duration:</strong> ninety days from kick-off to renewal
        conversation.
      </li>
      <li>
        <strong>Deal size:</strong> $75k pilot, positioned to grow into an
        annual programme at four times the value.
      </li>
    </ul>

    <h2>The funnel, in numbers</h2>
    <ul>
      <li>Audience reached in-target: 120,000 professionals</li>
      <li>Meaningful engagements (asset download, webinar sign-up): 3,600</li>
      <li>Verified + enriched leads handed to the advertiser: 900</li>
      <li>Sales-qualified opportunities the SDR team opened: 90</li>
      <li>Booked meetings inside the pilot window: 24</li>
      <li>Closed-won inside the pilot window: 3 (worth $2.1M in ARR)</li>
    </ul>
    <p>
      Three closed-won deals from a single ninety-day pilot changes the
      renewal conversation entirely. It also changes the internal
      conversation on the advertiser's side, which is where the annual
      programme decision actually happens.
    </p>

    <h2>The economics from the publisher side</h2>
    <ul>
      <li>Gross programme value: $75,000</li>
      <li>Direct media and enrichment cost: $18,000</li>
      <li>Programme margin: $57,000 (76%)</li>
      <li>Renewal probability, based on the pipeline booked: high</li>
    </ul>
    <p>
      Contrast that with the same audience surfaced through a display
      campaign at typical B2B CPMs: the gross would be a fraction, the
      margin thinner, and the renewal would depend on impression counts
      instead of pipeline.
    </p>

    <h2>What we would push back on</h2>
    <p>
      Numbers this clean rarely land on the first attempt. The two things
      that most often bend the model:
    </p>
    <ul>
      <li>
        <strong>Verification depth.</strong> If verification is shallow, the
        SDR team wastes cycles on non-buyers and the conversion from
        enriched lead to opportunity collapses.
      </li>
      <li>
        <strong>Speed-to-route.</strong> Every hour a verified lead sits in
        a CSV, the meeting-book rate roughly halves. Under thirty minutes is
        the target; five is achievable.
      </li>
    </ul>

    <p>
      Want the full model as a spreadsheet, plus the campaign template we
      use with publisher partners? Grab the{' '}
      <a href="/#playbook" style={{ color: '#1e88e5', fontWeight: 700 }}>
        2026 playbook
      </a>{' '}
      — the worked example is section three.
    </p>
  </>
);

export default AudienceExtensionExample;
